import { TrackingDeliveryEffect } from './tracking-delivery.effect';
import { TrackingPickupEffect } from './tracking-pickup.effect';

export const effects: any[] = [TrackingDeliveryEffect, TrackingPickupEffect];
